import * as React from 'react';
import * as styles from './ConfigurationMobile.css';
import { IConfigurationFormatted } from '../../../../types/project';
import { UIHeading3 } from '@cian/ui-kit';
import { useExpandableState } from '../../../../hooks';
import { DescriptionMarkup } from '../../../Description';
import { clsx } from 'clsx';

const LINE_COUNT = 3;
const LINE_HEIGHT = 24;
const FONT_SIZE = 16;

interface IConfigurationMobileProps extends IConfigurationFormatted {
  onClick(): void;
}

export const ConfigurationMobile: React.FC<IConfigurationMobileProps> = ({ name, price, description, onClick }) => {
  const textRef = React.useRef<HTMLDivElement>(null);
  const { expandable, maxHeight } = useExpandableState({
    textRef,
    lineCount: LINE_COUNT,
    lineHeight: LINE_HEIGHT,
    expanded: false,
  });

  return (
    <div className={styles['container']}>
      {(name || price) && (
        <div className={styles['header']}>
          <UIHeading3>{name}</UIHeading3>
          <UIHeading3 textAlign="right" whiteSpace="nowrap">
            {price}
          </UIHeading3>
        </div>
      )}
      {description && (
        <div>
          <div
            ref={textRef}
            style={{
              maxHeight,
              WebkitLineClamp: LINE_COUNT,
              lineHeight: `${LINE_HEIGHT}px`,
              fontSize: FONT_SIZE,
            }}
            className={clsx(styles['description'], expandable && styles['expandable'])}
          >
            <DescriptionMarkup html={description} />
          </div>
          {expandable && (
            <button className={styles['button']} onClick={onClick}>
              Подробнее
            </button>
          )}
        </div>
      )}
    </div>
  );
};
